console.log("start-promo-banner");


document.addEventListener("DOMContentLoaded", function() {
    const banner = document.getElementById("promo-banner");
    const toggleButton = document.querySelector(".promo-banner__btn");

    setTimeout(() => {
      banner.classList.remove("collapsed");
    }, 1000); 

    toggleButton.addEventListener("click", () => {
      banner.classList.toggle("collapsed");
    });
  });

console.log("end-promo-banner");
